import React from 'react';

import { ReactComponent as InsuranceCoverage } from '../../../../../../assets/icons/v3/insurance/insurance_coverage.svg';
import './SectionAnchor.scss';

export const SectionAnchor = () => {
  return (
    <div className="section-anchor-wrapper">
      <div className="background-shadow" />
      <div className="section-anchor">
        <InsuranceCoverage className="section-anchor-icon" />
      </div>
    </div>
  );
};

export default SectionAnchor;
